<!-- MODAL PARA MOSTRAR EL CHAT COMO ESTUDIANTE-->
<nb-card *ngIf="loginService.esEstudiante()" class="container-chat mb-0 resizable"
	[ngStyle]="{ top: chatModalPosition.top + 'px', left: chatModalPosition.left + 'px' }">

	<nb-card-header class="border-bottom-0 p-1 background_themecolor" (mousedown)="startDragging($event, 'chat')">
		<div class="d-flex justify-content-center align-content-center position-relative">
			<img class="icon-drag_indicator" src="../../../../assets/images/icons/drag_indicator.svg">
		</div>
	</nb-card-header>

	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeChatModal()"
			nbTooltip="{{ 'SIGMACOMPONENT.CERRAR' | translate }}" nbTooltipPlacement="left">
		</nb-icon>
	</div>

	<nb-card-body>
		<!-- Mensaje -->
		<div>
			<div class="d-flex justify-content-center msjAlert">
				<p>{{ 'CHAT.SENDREACTION' | translate }}</p>
			</div>
			<!-- Emojis -->
			<div class="d-flex flex-column gap-2 my-3">
				<div class="d-flex justify-content-center gap-3">
					<span class="emoji-icon pointer" *ngFor="let emoji of emojis"
						[class.selected]="selectedEmoji === emoji && emojiDisabled" [class.disabled]="emojiDisabled"
						(click)="onEmojiClick(emoji.icon)">
						{{ emoji.icon }}
					</span>
				</div>
				<div *ngIf="emojiDisabled" class="text-center text-muted">
					{{ 'CHAT.COOLDOWNEMOJI' | translate }} {{ emojiCountdown }}s
				</div>
			</div>
			<!-- Tags -->
			<div class="d-flex flex-column gap-2">
				<div class="d-flex flex-column justify-content-center gap-1">
					<nb-tag *ngFor="let tag of tags" class="nb-tag-custom pointer" size="small" appearance="filled"
						[text]="tag" [class.selected]="selectedTag === tag && tagDisabled" [class.disabled]="tagDisabled"
						(click)="onTagClick(tag)">
					</nb-tag>
				</div>
				<div *ngIf="tagDisabled" class="text-center text-muted">
					{{ 'CHAT.COOLDOWNMESSAGE' | translate }} {{ tagCountdown }}s
				</div>
			</div>
		</div>
		<!-- Encuestas -->
		<div *ngIf="surveysList.length == 0" class="d-flex justify-content-center msjAlert mt-4">
			<p>{{ 'CHAT.NOSURVEYS' | translate }}</p>
		</div>
		<div *ngIf="surveysList.length > 0" class="mt-4">
			<div *ngFor="let survey of surveysList; let i = index" class="survey-container" [class.disabled]="surveyDisabled">
				<div class="d-flex justify-content-center msjAlert my-2">
					<p>Encuesta enviada por el profesor</p>
				</div>
				<h6>{{ survey.question }}</h6>
				<p *ngIf="survey.multipleAnswer">({{ 'CHAT.SELECTMULTIPLE' | translate }})</p>
				<p *ngIf="!survey.multipleAnswer">({{ 'CHAT.SELECTONE' | translate }})</p>

				<div *ngFor="let option of survey.options; let j = index" class="option"
					[ngClass]="{ 'option-selected': option.selected, 'disabled': surveyDisabled }"
					(click)="!surveyDisabled && onOptionClick(survey, j)">
					<input type="checkbox" *ngIf="survey.multipleAnswer" [(ngModel)]="option.selected"
						style="pointer-events: none; margin-right: 10px;" />
					<input type="radio" *ngIf="!survey.multipleAnswer" [name]="'survey' + i" [checked]="option.selected"
						style="pointer-events: none; margin-right: 10px;" />
					{{ option.title }}
				</div>
				<div *ngIf="surveyDisabled && selectedSurveyIndex === i" class="text-center text-muted">
					{{ 'CHAT.CANCHANGEANSWER' | translate }} {{ surveyCountdown }}s
				</div>

				<button *ngIf="isAnyOptionSelected(survey) && !surveyDisabled" (click)="submitSurvey(i)"
					[disabled]="isSubmitting" [ngClass]="{ 'submitting': isSubmitting }">
					{{ isSubmitting ? 'Enviando...' : 'Enviar' }}
				</button>
			</div>
		</div>
	</nb-card-body>
	<div class="resize-handle"></div>
</nb-card>

<!-- MODAL PARA MOSTRAR EL CHAT COMO PROFE-->
<nb-card *ngIf="loginService.esProfesor()"
	class="container-chat mb-0 resizable" [ngStyle]="{ top: chatModalPosition.top + 'px', left: chatModalPosition.left + 'px' }">

	<nb-card-header class="border-bottom-0 p-0" (mousedown)="startDragging($event, 'chat')">
		<div class="d-flex justify-content-center align-content-center position-relative background_themecolor p-1">
			<img class="icon-drag_indicator" src="../../../../assets/images/icons/drag_indicator.svg">
		</div>
		<!-- Emojis -->
		<div class="d-flex justify-content-center gap-3 pt-4 pb-2" *ngIf="!newSurvey">
			<span class="emoji-icon" *ngFor="let emoji of emojis">
				<div class="position-relative text-center">
					<div>{{ emoji.icon }}</div>
					<span class="background-icon-action-red" *ngIf="emoji.count > 0">{{ emoji.count }}</span>
				</div>
			</span>
		</div>
		<!-- Titulo nueva encuesta -->
		 <h6 class="d-flex justify-content-center pt-4" *ngIf="newSurvey">{{ 'CHAT.CREATESURVEY' | translate }}</h6>
	</nb-card-header>

	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeChatModal()"
			nbTooltip="{{ 'SIGMACOMPONENT.CERRAR' | translate }}" nbTooltipPlacement="left">
		</nb-icon>
	</div>

	<nb-card-body [ngClass]="{ 'd-flex': !newSurvey, 'flex-column-reverse': !newSurvey }">
		<!-- Mensajes -->
		<div class="d-flex flex-column gap-2" *ngIf="!newSurvey">
			<div *ngFor="let tag of tagsProfe" class="cont-msg gap-2">
				<p *ngIf="verNombre && !tag.msg.startsWith('ENCUESTA-')" class="{{tag.class}}">{{tag.name}}</p>
				<p *ngIf="verNombre && tag.msg.startsWith('ENCUESTA-')" class="nombre-profe">{{ 'HEADER.PROFESOR' | translate }}:
				</p>
				<p *ngIf="!verNombre" class="{{tag.class}}">*****</p>
				<span *ngIf="!tag.msg.startsWith('ENCUESTA-')">{{tag.msg}}</span>
				<ng-container *ngIf="tag.msg.startsWith('ENCUESTA-')">
					<div class="encuesta-container" *ngIf="obtenerEncuestaCompleta(tag.msg) as encuesta">
						<p class="encuesta-pregunta">{{ encuesta.question }}</p>

						<div class="encuesta-opcion" *ngFor="let resultado of encuesta.opciones">
							<div class="encuesta-opcion-header">
								<span class="encuesta-opcion-title">{{ resultado.title }}</span>
								<span class="encuesta-votos">
									{{ resultado.votos }} ({{ getPorcentaje(resultado.votos, encuesta.opciones) | number:'1.0-0' }}%)
								</span>
							</div>
							<div class="encuesta-barra">
								<div
									class="encuesta-barra-progreso"
									[style.width.%]="getPorcentaje(resultado.votos, encuesta.opciones)">
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<!-- Nueva encuesta -->
		<div class="d-flex flex-column gap-2" *ngIf="newSurvey">
			<span>{{ 'QUIZZES.QUIZ' | translate }}</span>
			<input type="text" nbInput fullWidth shape="round" placeholder="" fieldSize="small" [(ngModel)]="pregunta">
			<span>{{ 'GRUPOS.OPCIONES' | translate }}</span>
			<div *ngFor="let opcion of opciones; let i = index; trackBy: trackByIndex" class="d-flex align-items-center gap-2">
				<input type="text" nbInput fullWidth shape="round" placeholder="Opción {{ i + 1 }}" fieldSize="small"
					[(ngModel)]="opciones[i]">
				<nb-icon icon="close-outline" nbTooltip="Eliminar opción" class="cursor-pointer text-danger"
					(click)="eliminarOpcion(i)">
				</nb-icon>
			</div>
			<div class="d-flex flex-column gap-4">
				<div class="d-flex justify-content-center align-items-center">
					<nb-icon nbTooltip="Agregar opción" icon="plus-circle-outline" (click)="agregarOpcion()"
						class="pointer text-primary">
					</nb-icon>
				</div>
				<nb-toggle class="item-profile" [(ngModel)]="multiAnswer" (ngModelChange)="enableMultiAnswer($event)">
					{{ 'CHAT.MULTIPLEANSWER' | translate }}
				</nb-toggle>
			</div>
		</div>
	</nb-card-body>
	<nb-card-footer class="border-top-0">
		<div *ngIf="newSurvey" class="d-flex justify-content-center align-items-center gap-4">
			<button nbButton (click)="cancelarEncuesta()" class="btn-red"> {{ 'GLOBALS.CANCEL' | translate }}
				<nb-icon icon="close-circle-outline"></nb-icon>
			</button>
			<button nbButton (click)="guardarEncuesta()" class="btn-themecolor"> {{ 'GLOBALS.OK' | translate }}
				<nb-icon icon="checkmark-circle-2-outline"></nb-icon>
			</button>
		</div>

		<div class="gap-2 cont-input" *ngIf="!newSurvey">
			<input type="text" nbInput fullWidth shape="round" placeholder="" disabled fieldSize="small">
			<nb-icon icon="more-vertical-outline" class="open-modal-icon" (click)="openConfigModal()"></nb-icon>
		</div>
	</nb-card-footer>
	<!-- Configuración del Chat -->
	<div class="config-modal" [class.show]="showConfigModal" style="position: absolute; z-index: 1000;">
		<nb-card class="m-0">
			<nb-card-header>{{ 'CHAT.CONFIG' | translate }}</nb-card-header>
			<nb-card-body>
				<div class="d-flex gap-2 mb-3">
					<nb-toggle class="item-profile" [(ngModel)]="verNombre" (ngModelChange)="isVisibleName($event)">
					</nb-toggle>
					<p class="m-0" *ngIf="!verNombre">{{ 'CHAT.SHOW' | translate }}</p>
					<p class="m-0" *ngIf="verNombre">{{ 'CHAT.HIDE' | translate }}</p>
				</div>
				<!-- Activacion Encuestas -->
				<div class="d-flex gap-2 align-items-center">
					<nb-icon (click)="_newSurvey()" icon="question-mark-outline" class="pointer size-icon"></nb-icon>
					<p class="m-0">{{ 'CHAT.NEWSURVEY' | translate }}</p>
				</div>
			</nb-card-body>
		</nb-card>
	</div>
	<div class="resize-handle"></div>
</nb-card>
